import styles from './YearSelector.module.css';
const YRS=Array.from({length:37},(_,i)=>2026-i);
export default function YearSelector({year,onChange,dates}) {
  const f=d=>new Date(d).toLocaleDateString('en',{month:'short',day:'numeric'});
  const lbl=dates?`🌙 Ramadan ${year}: ${f(dates.start)} – ${f(dates.end)}`:"";
  return (<div className={styles.w}>
    <label className={styles.lbl}>Select Year</label>
    <div className={styles.row}>
      <button className={styles.arr} onClick={()=>onChange(y=>Math.max(1990,y-1))} disabled={year<=1990}>‹</button>
      <select className={styles.sel} value={year} onChange={e=>onChange(+e.target.value)}>
        {YRS.map(y=><option key={y} value={y}>{y}</option>)}
      </select>
      <button className={styles.arr} onClick={()=>onChange(y=>Math.min(2026,y+1))} disabled={year>=2026}>›</button>
    </div>
    {lbl&&<span className={styles.badge}>{lbl}</span>}
    <input type="range" min={1990} max={2026} value={year} onChange={e=>onChange(+e.target.value)} className={styles.slider}/>
    <div className={styles.ticks}><span>1990</span><span>2000</span><span>2010</span><span>2020</span><span>2026</span></div>
  </div>);
}